
import { HuntrixSong } from './types';

export const APT: HuntrixSong = {
    id: 'APT',
    title: "APT.",
    artist: "ROSÉ & Bruno Mars",
    midiFileName: "APT.mid",
    mp3FileName: "APT.mp3",
    sequencedTracks: [
        {
            "name": "909 Drum Kit",
            "notes": [
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Electric Drum Kit",
            "notes": [
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "D2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.16
                }
            ]
        },
        {
            "name": "2023 Drum Kit",
            "notes": [
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.24
                }
            ]
        },
        {
            "name": "2023 Drum Kit 2",
            "notes": [
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "2:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "2:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "4:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "5:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "6:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "7:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "8:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "9:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "10:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "11:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "12:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "13:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "14:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "15:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "19:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "20:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "22:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D1",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "24:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "25:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "26:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "28:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "29:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "31:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "32:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "34:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "35:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "36:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "37:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "38:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "39:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "40:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C#1",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "41:3:2",
                    "velocity": 0.16
                }
            ]
        },
        {
            "name": "Electric Drum Kit 3",
            "notes": [
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.32
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.32
                }
            ]
        },
        {
            "name": "EDM Kit (E)",
            "notes": [
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.11
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.11
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.11
                },
                {
                    "name": "C#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.11
                }
            ]
        },
        {
            "name": "Electric Drum Kit 2",
            "notes": [
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "2:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "2:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "3:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "4:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
            ]
        },
        {
            "name": "Electric Drum Kit 4",
            "notes": [
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.34
                },
                {
                    "name": "D#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.34
                }
            ]
        },
        {
            "name": "Bass Guitar",
            "notes": [
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Trombone 2",
            "notes": [
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Trombone",
            "notes": [
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "21:1:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.53
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.53
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "37:1:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.53
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "41:1:0",
                    "velocity": 0.53
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.53
                }
            ]
        },
        {
            "name": "French Horn",
            "notes": [
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "2n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Grand Piano",
            "notes": [
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "5:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "5:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "2n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "8n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "29:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#2",
                    "duration": "2n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "41:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Saxophone",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Square",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.16
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.16
                }
            ]
        },
        {
            "name": "Grand Piano 2",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "1m",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "1m",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "1m",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "4n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "1m",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "1m",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "1m",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "1m",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "1m",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "1m",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "4n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "1m",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "1m",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "41:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Electric Drum Kit 5",
            "notes": [
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.35
                }
            ]
        },
        {
            "name": "Reverse",
            "notes": [
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Xylophone",
            "notes": [
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Electric Piano",
            "notes": [
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "4:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "4:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "5:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "9:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "2n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "2n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#6",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G6",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F6",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#6",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D6",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#6",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "29:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Triangle",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "1m",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "4n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C6",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#5",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Sine",
            "notes": [
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#3",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "4n",
                    "time": "41:2:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Square 2",
            "notes": [
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                }
            ]
        }
    ],
    structure: [
        { 
            type: 'INTRO', 
            duration: 16, 
            rhythm: 'MINIMAL', 
            lyrics: ["Chaeyoung-iga joahaneun", "Random game", "Random game", "Game start!"] 
        },
        { 
            type: 'CHORUS', 
            duration: 32, 
            rhythm: 'HOUSE', 
            lyrics: [
                "Apateu, apateu! Apateu, apateu!",
                "Apateu, apateu! Uh, uh-huh, uh-huh!",
                "Apateu, apateu! Apateu, apateu!",
                "Apateu, apateu! Uh, uh-huh, uh-huh!"
            ]
        },
        { 
            type: 'VERSE', 
            duration: 16, 
            rhythm: 'HOUSE', 
            lyrics: [
                "Kissy face, kissy face, sent to your phone, but",
                "I'm tryna kiss your lips for real (Uh-huh, uh-huh)",
                "Red hearts, red hearts, that's what I'm on, yeah",
                "Come give me somethin' I can feel, oh-oh, oh"
            ]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 16, 
            rhythm: 'BUILDUP', 
            lyrics: [
                "Don't you want me like I want you, baby?",
                "Don't you need me like I need you now?",
                "Sleep tomorrow, but tonight, go crazy",
                "All you gotta do is just meet me at the"
            ]
        },
        { 
            type: 'CHORUS', 
            duration: 32, 
            rhythm: 'HOUSE', 
            lyrics: [
                "Apateu, apateu! Apateu, apateu!",
                "Apateu, apateu! Uh, uh-huh, uh-huh!",
                "Apateu, apateu! Apateu, apateu!",
                "Apateu, apateu! Uh, uh-huh, uh-huh!"
            ]
        },
        { 
            type: 'VERSE', 
            duration: 16, 
            rhythm: 'TRAP', 
            lyrics: [
                "It's whatever, it's whatever, it's whatever you like (Woo)",
                "Turn this apateu into a club (Uh-huh, uh-huh)",
                "I'm talkin' drink, dance, smoke, freak, party all night",
                "Geonbae, geonbae, girl, what's up? Oh-oh, oh"
            ]
        },
        { 
            type: 'PRE_CHORUS', 
            duration: 16, 
            rhythm: 'BUILDUP', 
            lyrics: [
                "Don't you want me like I want you, baby?",
                "Don't you need me like I need you now?",
                "Sleep tomorrow, but tonight, go crazy",
                "All you gotta do is just meet me at the"
            ]
        },
        { 
            type: 'CHORUS', 
            duration: 32, 
            rhythm: 'HOUSE', 
            lyrics: [
                "Apateu, apateu! Apateu, apateu!",
                "Apateu, apateu! Uh, uh-huh, uh-huh!",
                "Apateu, apateu! Apateu, apateu!",
                "Apateu, apateu! Uh, uh-huh, uh-huh!"
            ]
        },
        { 
            type: 'BRIDGE', 
            duration: 16, 
            rhythm: 'MINIMAL', 
            lyrics: [
                "Hey, so now you know the game. Are you ready?",
                "'Cause I'm comin' to get ya, get ya, get ya",
                "Hold on, hold on, I'm on my way",
                "Yeah, yeah, yeah-yeah, yeah, I'm on my way"
            ]
        },
        { 
            type: 'CHORUS', 
            duration: 32, 
            rhythm: 'HOUSE', 
            lyrics: [
                "Apateu, apateu! Apateu, apateu!",
                "Just meet me at the (Uh, uh-huh, uh-huh)",
                "Apateu, apateu! Apateu, apateu!",
                "Just meet me at the (Uh, uh-huh, uh-huh)"
            ]
        }
    ],
    musicalData: {
        keyRoot: "C", 
        scale: "minor", // Based on provided letter notes (Eb, Bb, Ab implies C Minor context)
        bpm: 149,
        defaultTheme: {
            chordProgression: [0, 3, 0, 4], 
            bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
            melodyPattern: [0, 0, 0, 0, 0, 0, 0, null] // Monotone chant
        },
        themes: {
            INTRO: {
                chordProgression: [0, 0],
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0],
                melodyPattern: [0, null, 0, null, 0, null, 0, null, 0, 0, 0, 0, 0, 0, 0, 0]
            },
            CHORUS: {
                chordProgression: [0, 0, 0, 0], // Stay on root for the chant
                bassPattern: [1, 0, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 0, 1, 0], // Driving
                melodyPattern: [0, 0, 0, 0, 0, 0, 0, null, 0, 0, 0, 0, 0, 0, 0, null]
            },
            VERSE: {
                chordProgression: [0, 5], 
                bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
                melodyPattern: [7, 7, 7, 5, 0, null, null, null]
            },
            PRE_CHORUS: {
                chordProgression: [3, 4, 5, 4],
                bassPattern: [1, 1, 1, 1, 1, 1, 1, 1],
                melodyPattern: [5, 5, 7, 7, 9, 9, 12, 12]
            }
        }
    }
};
